import React from "react";
import grp1 from "../../Assets/img/Group 40806.svg";
import grp2 from "../../Assets/img/Group 40807.svg";
import quotes1 from "../../Assets/img/quotes 1.svg";
import testi from "../../Assets/img/Ellipse 456 (1).svg";
// Logos
import logo1 from "../../Assets/img/logo_2x 5.svg";
import logo2 from "../../Assets/img/logo-v1 1 (1).svg";
import logo3 from "../../Assets/img/logo-v1 1.svg";
import logo4 from "../../Assets/img/logo 9.svg";
import logo5 from "../../Assets/img/logo 8.svg";
import logo6 from "../../Assets/img/logo 7.svg";
import logo7 from "../../Assets/img/logo 6.svg";

const Testimonial = () => {
  return (
    <>
      <section className="benner-employee py-2">
        <div className="container position-relative">
          {/* Carousel */}
          <div
            id="testimonialCarousel"
            className="carousel slide"
            data-bs-ride="carousel"
            data-bs-interval="4000" // auto slide every 4 seconds
          >
            <div className="carousel-inner">
              {/* Slide 1 */}
              <div className="carousel-item active">
                <div className="author-wrapper d-flex align-items-center">
                  <div className="author-img-wrapper">
                    <img src={testi} alt="HR Manager" />
                  </div>
                  <div className="testimonial-content position-relative flex-grow-1">
                    <div className="quote-icon-start">
                      <img src={quotes1} alt="quote" />
                    </div>
                    <p>
                      Finding the right candidates used to take weeks. With
                      Anaxis, we filled key roles in days. The platform’s talent
                      pool is impressive, and the support team truly understands
                      our hiring needs. It’s been a game-changer for scaling our
                      business.
                    </p>
                    <div className="author">
                      – HR Manager,{" "}
                      <span className="author-title">Atlas Tech Solutions</span>
                    </div>
                    <div className="quote-icon-end">
                      <img src={quotes1} alt="quote" />
                    </div>
                  </div>
                </div>
              </div>

              {/* Slide 2 */}
              <div className="carousel-item">
                <div className="author-wrapper d-flex align-items-center">
                  <div className="author-img-wrapper">
                    <img src={testi} alt="Recruiting Lead" />
                  </div>
                  <div className="testimonial-content position-relative flex-grow-1">
                    <div className="quote-icon-start">
                      <img src={quotes1} alt="quote" />
                    </div>
                    <p>
                      The recruitment platform revolutionized our process. The
                      quality and communication are top-notch.
                    </p>
                    <div className="author">
                      – Recruiting Lead,{" "}
                      <span className="author-title">Bright Horizons</span>
                    </div>
                    <div className="quote-icon-end">
                      <img src={quotes1} alt="quote" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* ✅ Prev Button */}
            <button
              className="carousel-control-prev outer-nav"
              type="button"
              data-bs-target="#testimonialCarousel"
              data-bs-slide="prev"
            >
              <span aria-hidden="true">
                <img src={grp1} alt="Previous" />
              </span>
              <span className="visually-hidden">Previous</span>
            </button>

            {/* ✅ Next Button */}
            <button
              className="carousel-control-next outer-nav"
              type="button"
              data-bs-target="#testimonialCarousel"
              data-bs-slide="next"
            >
              <span aria-hidden="true">
                <img src={grp2} alt="Next" />
              </span>
              <span className="visually-hidden">Next</span>
            </button>
          </div>
        </div>
      </section>

      {/* Logos Section */}
      <section className="logos">
        <div className="header" style={{ borderBottom: "none" }}>
          Organizations That Rely on Anaxis
        </div>
        <div className="logo-slider">
          <div className="logo-track">
            <img src={logo1} alt="Kivonyx Healthcare Pvt. Ltd." />
            <img src={logo2} alt="Krinal Shah" />
            <img src={logo3} alt="BluLagoon" />
            <img src={logo4} alt="BioMatrix" />
            <img src={logo5} alt="Advisors" />
            <img src={logo6} alt="Kivonyx Healthcare Pvt. Ltd." />
            <img src={logo7} alt="Krinial Shah" />

            {/* Repeat for smooth slider */}
            <img src={logo1} alt="Kivonyx Healthcare Pvt. Ltd." />
            <img src={logo2} alt="Krinal Shah" />
            <img src={logo3} alt="BluLagoon" />
            <img src={logo4} alt="BioMatrix" />
            <img src={logo5} alt="Advisors" />
            <img src={logo6} alt="Kivonyx Healthcare Pvt. Ltd." />
            <img src={logo7} alt="Krinial Shah" />
          </div>
        </div>
      </section>
      <style jsx>
        {`
          .carousel-control-prev,
          .carousel-control-next {
            display: block !important;
          }
        `}
      </style>
    </>
  );
};

export default Testimonial;
